import { PayloadAction, createSlice } from '@reduxjs/toolkit';

import { IMainCatalogItem } from '../../shared/types/main-catalog';

import { ILayoutState } from './layout.interface';

const initialState: ILayoutState = {
  processes: [],
  page: 'home',
  title: null,
  snackbarIsOpen: false,
  snackbarTitle: '',
  description:
    'У нас Вы можете купить сварочное оборудование, строительные материалы, инструменты и многое другое по оптово-розничным ценам',
  titleTab: '',
  navigationPath: 'home',
};

export const layoutSlice = createSlice({
  name: 'mainPageSlice',
  initialState,
  reducers: {
    setProcesses(state, action: PayloadAction<IMainCatalogItem[]>) {
      state.processes = action.payload;
    },
    setPage(
      state,
      action: PayloadAction<
        | 'home'
        | 'catalog'
        | 'other'
        | 'basket'
        | 'publication'
        | 'favorite'
        | 'searchPage'
        | 'cardPage'
        | 'order'
      >
    ) {
      state.page = action.payload;
    },
    setTitle(state, action: PayloadAction<string | null>) {
      state.title = action.payload;
    },
    setOpenSnackbar(state, action: PayloadAction<string>) {
      state.snackbarIsOpen = true;
      state.snackbarTitle = action.payload;
    },
    closeSnackbar(state) {
      state.snackbarIsOpen = false;
    },
    setDescription(state, action: PayloadAction<string>) {
      state.description = action.payload;
    },
    setTitleTab(state, action: PayloadAction<string>) {
      state.titleTab = action.payload;
    },
    setNavigationPath(state, action: PayloadAction<string>) {
      state.navigationPath = action.payload;
    },
  },
});
export const layoutActions = layoutSlice.actions;
export const { reducer } = layoutSlice;
